const doc = [({"en":({"adminConstantLanguageType":({"en":"English", "ja":"Japanese", "ko":"Korean", "zhCn":"Chinese (Simplified)", "zhTw":"Chinese (Traditional)"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;